import React, { useState } from 'react';
import { exportRaceDiagnostics } from '../api';

export default function AdminRaceLogDownload({ races = [], buttonStyle }) {
  const [selected, setSelected] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const nearest = [...races].filter(r => !r.cancelled && Number.isFinite(Date.parse(r.race_date)))
    .sort((a, b) => Math.abs(Date.parse(a.race_date) - Date.now()) - Math.abs(Date.parse(b.race_date) - Date.now()))[0];
  const raceId = selected || String(nearest?.id || races[0]?.id || '');
  async function download() {
    setBusy(true); setMessage('');
    try {
      const blob = await exportRaceDiagnostics(raceId);
      if (!blob.size) { setMessage('No saved logs for this race yet.'); return; }
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      try {
        link.href = url;
        link.download = `race-${raceId}-diagnostics.ndjson`;
        document.body.appendChild(link);
        link.click();
      } finally {
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      }
      setMessage('Log downloaded.');
    } catch (error) {
      setMessage([401, 403].includes(error.response?.status)
        ? 'Admin access expired. Sign in again to download logs.'
        : 'Could not download logs. Please try again.');
    } finally { setBusy(false); }
  }
  return (
    <div style={{ marginTop: 18, paddingTop: 14, borderTop: '1px solid #222' }}>
      <label htmlFor="race-log-select" style={{ display: 'block', fontSize: 12, color: '#aaa', marginBottom: 8 }}>
        Race sync logs
      </label>
      <select id="race-log-select" value={raceId} disabled={busy || !races.length}
        onChange={event => { setSelected(event.target.value); setMessage(''); }}
        style={{ width: '100%', minWidth: 0, padding: '8px', marginBottom: 8, background: '#0d0d0d',
          color: '#ddd', border: '1px solid #333', borderRadius: 4 }}>
        {!races.length && <option value="">No races available</option>}
        {races.map(race => <option key={race.id} value={String(race.id)}>{race.circuit || race.name} · {race.season}</option>)}
      </select>
      <button style={{ ...buttonStyle, width: '100%' }} onClick={download} disabled={busy || !raceId}>
        {busy ? 'Downloading…' : 'Download race log'}
      </button>
      <p style={{ fontSize: 11, color: '#888', marginTop: 8 }}>Saved automatically. Last 7 days, including completed races.</p>
      {message && <p role="status" style={{ fontSize: 12, color: '#f9b000', marginTop: 8 }}>{message}</p>}
    </div>
  );
}
